import { useState } from 'react'
import { useLang } from '../i18n'

const APP_URL = import.meta.env.VITE_APP_URL || 'http://localhost:3004'
const CONTACT_EMAIL = 'contact@ubigym.ma'
const color = '#10b981'

export default function Header() {
  const [open, setOpen] = useState(false)
  const { t, lang, setLang } = useLang()
  const n = t.nav

  const navLinks = [
    [n.howItWorks, '#how'],
  ]

  return (
    <header style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000, background: 'rgba(10,10,10,0.92)', backdropFilter: 'blur(12px)', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: color, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
              <path d="M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z"/>
            </svg>
          </div>
          <span style={{ color: 'white', fontWeight: 800, fontSize: 18, letterSpacing: '-0.3px' }}>ubi<span style={{ color }}>gym</span></span>
        </a>

        <nav style={{ display: 'flex', gap: 28, alignItems: 'center' }} className="desktop-nav">
          {navLinks.map(([l, h]) => (
            <a key={h} href={h} style={{ color: 'rgba(255,255,255,0.55)', textDecoration: 'none', fontSize: 14, fontWeight: 500, transition: 'color 0.2s' }}
              onMouseEnter={e => e.target.style.color = 'white'}
              onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.55)'}>
              {l}
            </a>
          ))}
        </nav>

        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }} className="desktop-nav">
          {/* Language switcher */}
          <button onClick={() => setLang(lang === 'fr' ? 'en' : 'fr')}
            style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.6)', fontSize: 12, fontWeight: 700, padding: '5px 10px', borderRadius: 6, cursor: 'pointer', letterSpacing: '0.05em' }}>
            {lang === 'fr' ? 'EN' : 'FR'}
          </button>
          <a href={`${APP_URL}/login`} style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14, fontWeight: 500, textDecoration: 'none', padding: '8px 14px', transition: 'color 0.2s' }}
            onMouseEnter={e => e.target.style.color = 'white'}
            onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.55)'}>
            {n.signIn}
          </a>
          <a href={`mailto:${CONTACT_EMAIL}`} style={{ background: color, color: 'white', fontSize: 14, fontWeight: 700, textDecoration: 'none', padding: '9px 20px', borderRadius: 8 }}>
            {n.startFree}
          </a>
        </div>

        <button onClick={() => setOpen(o => !o)} style={{ display: 'none', background: 'none', border: 'none', color: 'white', fontSize: 22, cursor: 'pointer', lineHeight: 1 }} className="mobile-menu-btn">
          {open ? '✕' : '☰'}
        </button>
      </div>

      {open && (
        <div style={{ background: '#111', borderTop: '1px solid rgba(255,255,255,0.08)', padding: '16px 24px 24px' }}>
          {navLinks.map(([l, h]) => (
            <a key={h} href={h} onClick={() => setOpen(false)} style={{ display: 'block', color: 'rgba(255,255,255,0.7)', textDecoration: 'none', padding: '12px 0', fontSize: 15, fontWeight: 500 }}>{l}</a>
          ))}
          <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
            <a href={`mailto:${CONTACT_EMAIL}`} onClick={() => setOpen(false)} style={{ flex: 1, padding: '13px 0', background: color, color: 'white', textDecoration: 'none', textAlign: 'center', borderRadius: 8, fontWeight: 700, fontSize: 14 }}>{n.startFree}</a>
            <button onClick={() => setLang(lang === 'fr' ? 'en' : 'fr')} style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.1)', color: 'white', fontWeight: 700, fontSize: 12, padding: '0 16px', borderRadius: 8, cursor: 'pointer' }}>
              {lang === 'fr' ? 'EN' : 'FR'}
            </button>
          </div>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: block !important; }
        }
      `}</style>
    </header>
  )
}
